import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { clickOnAuthor } from '@/pages/editorial/tracking';
import { Provision } from '@/helpers/composables/useArticle';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorBox',
  props: {
    author: null
  },
  setup(__props: any) {

const props = __props as { author: Provision['author'] }



const authorContent = computed(() => props.author.content);

const trackAuthorClick = () =>
	clickOnAuthor({
		category: 'persons_credit_name',
		action: 'clicked',
		label: 'AUTHOR',
		property: props.author.id,
	});

return { __sfc: true,props, authorContent, trackAuthorClick }
}

})